


























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Step } from '../../mixins';
import { RootStoreHelper } from '../../../core/mixins';
import Condition from './Condition.vue';
import { FilterConditions, VariableValue } from '../../../core/models';
import StepperConfig from './StepperConfig.vue';
import { ElementType, Method } from '../../../core/utils';

@Component<ConditionStepper>({
    components: { StepperConfig, Condition }
})
export default class ConditionStepper extends Mixins(Step, RootStoreHelper) {
    @Prop() conditions: FilterConditions[];
    @Prop() addCondition: Method<FilterConditions, void>;
    @Prop() removeCondition: Method<FilterConditions, void>;
    @Prop() existConditions: Method<void, boolean>;
    @Prop() currentStep: number;
    // disableRight: boolean = true;

    get variables(): VariableValue[] {
        return this.$_getVariables ? Object.values(this.$_getVariables) : [];
    }

    get condition(): any {
        return this.$refs.condition as any;
    }

    get disableNext(): boolean {
        return !this.existConditions();
    }

    handleNext(): void {
        if (this.existConditions()) {
            this.$_nextStep(2);
        }
    }

    handleLeft(elementSelected: ElementType): void {
        this.removeCondition(elementSelected as FilterConditions);
        this.condition.updateFilterCondition(elementSelected as FilterConditions);
        this.condition.resetValidation();
    }

    handleRight(): void {
        (this.condition.validate() as Promise<boolean>).then(valid => {
            if (valid) {
                const condition = this.condition.getFilterCondition();
                this.addCondition(condition);
                this.condition.clearInputs();
                this.condition.resetValidation();
                this.condition.setFocus();
            }
        });
    }

    resetForm(): void {
        this.condition.clear();
        this.condition.resetValidation();
        this.condition.setFocus();
    }
}
